export const RESOURCES = {
  general: [
    {
      name: 'How to Get an Internship',
      author: 'Glassdoor',
      link: 'https://www.glassdoor.com/blog/guide/how-to-get-an-internship/',
      type: 'article',
      description: "The Glassdoor team discusses the entirety of the internship application process, from those initial searches all the way to finalising an offer."
    },
    {
      name: 'How to Get an Internship Without Experience',
      author: 'Alexis Choi',
      link: 'https://www.youtube.com/watch?v=KynMm9ucC94', 
      type: 'video',
      description: 'Recruiter Alexis Choi explains how to standout from other applicants when you have no prior work experience.'
    },
    {
      name: "Steps in the Application Process",
      author: 'The Balance Careers',
      link: 'https://www.thebalancecareers.com/job-application-process-2061600',
      type: 'article',
      description: 'Learn what the typical stages of the application process looks like.'
    }
  ],
  documents: [
    { 
      name: 'Resume and Cover Letter Guide',
      author: 'The Balance Careers',
      link: 'https://www.thebalancecareers.com/resume-and-cover-letter-writing-guide-2063178',
      type: 'article',
      description: 'Learn how to write an exceptional resume and cover letter, includes techniques and samples!'
    },
    { 
      name: "Resume.io",
      author: 'Resume.io',
      link: 'https://resume.io/resume-examples',
      type: 'website',
      description: 'Check out successful resumes and cover letters as well as a variety of writing guides.'
    },
    {
      name: 'Get Professional Feedback',
      author: 'Resume Worded',
      link: 'https://resumeworded.com/score',
      type: 'website',
      description: 'Get your application materials reviewed by professionals'
    }
  ],
  networking: [
    {
      name: 'How to Effectively Use LinkedIn to Network',
      author: 'Think Bespoke',
      link: 'https://thinkbespoke.com.au/2018/05/how-to-network-more-effectively-on-linkedin.html',
      type: 'article',
      description: 'Learn how to use LinkedIn to network and find more internship opportunities'
    },
    {
      name: "How to Network if You're an Introvert",
      author: 'Charisma Command',
      link: 'https://www.youtube.com/watch?v=FAPySGLL3gg',
      type: 'video',
      description: 'Nervous about networking? Learn how to change your mindset and expand your network'
    },
    { 
      name: 'Find Networking Events',
      author: 'EventBrite',
      link: 'https://www.eventbrite.com.au/d/australia--sydney/networking/',
      type: 'website',
      description: 'Find networking events near you'
    }
  ],
  interviews: [
    {
      name: 'How to Ace an Interview',
      author: 'Indeed',
      link: 'https://au.indeed.com/career-advice/interviewing/how-to-ace-an-interview',
      type: 'article',
      description: "Tips and Tricks for acing those nerve-racking interviews. It's a lot more than just answering questions!"
    },
    {
      name: 'Personal Pitch',
      author: 'Dan Lok',
      link: 'https://www.youtube.com/watch?v=5v-wyR5emRw',
      type: 'video',
      description: "Dreading the common 'Tell me about yourself' interview opener? Look no further than Dan Lok's video about acing this very question!"
    },
    {
      name: 'The STAR Method',
      author: 'Indeed',
      link: 'https://au.indeed.com/career-advice/interviewing/how-to-use-the-star-interview-response-technique',
      type: 'article',
      description: 'The STAR method is perfect for answering those pesky behavioural interview questions. Learn more about it now.'
    }
  ]
}